module.exports = __webpack_public_path__ + "static/img/IMG_20170901_212106-PANO.2bae9ed0.jpg";